// extracted by mini-css-extract-plugin
export var StoreRating__Title = "Rating-module--StoreRating__Title--1wm-p";
export var StoreRating = "Rating-module--StoreRating--NV_lX";